module.exports = __webpack_public_path__ + "img/feedback-up.7490817d.png";